
import React from "react";

// Define the icon paths for principles and stats from /HomePage/icons/
const principleData = [
  {
    title: "Inclusivity",
    desc: "Promoting shared prosperity by empowering women-led enterprises, youth, and underrepresented sectors.",
    iconUrl: "/HomePage/icons/Inclusivity.png", // blue tone - inclusivity
    image: "/Images/image6.jpeg",
    bgColor: "#4FB1FF", // or use as needed
  },
  {
    title: "Innovation & Technology",
    desc: "Supporting digital transformation, e-commerce, and smart cross-border trade practices.",
    iconUrl: "/HomePage/icons/technology.png", // yellow tone - innovation
    image: "/Images/image8.jpeg",
    bgColor: "#FFD700",
  },
  {
    title: "Strategic Impact",
    desc: "Identifying opportunities, adapting to global shifts, and fostering sustainable growth.",
    iconUrl: "/HomePage/icons/startup.png", // blue/yellow tone - impact/insight
    image: "/Images/image3.jpeg",
    bgColor: "#4FB1FF",
  },
  {
    title: "Collaborative Network",
    desc: "Building a resilient global ecosystem through partnerships, mentorship, and knowledge sharing.",
    iconUrl: "/HomePage/icons/collaboration.png", // yellow tone - partnership
    image: "/Images/image5.jpeg",
    bgColor: "#FFD700",
  },
];

const statsData = [
  {
    title: "Inclusivity",
    desc: "Promoting shared prosperity by empowering women-led enterprises, youth, and underrepresented sectors.",
    iconUrl: "/HomePage/icons/Inclusivity.png", // blue tone - inclusivity
    color: "#4FB1FF",
  },
  {
    title: "Innovation & Technology",
    desc: "Supporting digital transformation, e-commerce, and smart cross-border trade practices.",
    iconUrl: "/HomePage/icons/technology.png", // yellow tone - innovation
    color: "#FFD700",
  },
  {
    title: "Strategic Impact",
    desc: "Identifying opportunities, adapting to global shifts, and fostering sustainable growth.",
    iconUrl: "/HomePage/icons/startup.png", // blue/yellow tone - impact/insight
    color: "#4FB1FF",
  },
  {
    title: "Collaborative Network",
    desc: "Building a resilient global ecosystem through partnerships, mentorship, and knowledge sharing.",
    iconUrl: "/HomePage/icons/collaboration.png", // yellow tone - partnership
    color: "#FFD700",
  },
];

const CorePrinciples = () => {
  return (
    <section className="bg-[#F8FAFC] py-20">
      <div className="container mx-auto px-6 lg:px-16">
        {/* Section Header */}
        <div className="text-center mb-16">
          {/* <h5 className="uppercase text-[#4FB1FF] tracking-wider text-sm font-semibold mb-3">
            Our Core Principles
          </h5> */}
          <h2 className="text-5xl md:text-6xl font-Agatho_Regular  font-extrabold text-[#0B1D33] mb-4">
            Driving <span className="">Collaboration</span> &{" "}
            <span className="">Impact</span>
          </h2>
          <p className="text-gray-600 max-w-2xl mx-auto font-bold text-xl leading-relaxed  font-Agatho_Regular ">
            Enabling inclusive, innovative, and sustainable growth for businesses across
            <br />
            <span className="font-bold text-2xl md:text-2xl">
              India and Europe.
            </span>
          </p>
        </div>

        {/* Principle Cards */}
        <div className="grid lg:grid-cols-2 gap-8 mb-16">
          {principleData.map((p, i) => (
            <div
              key={i}
              className="bg-white rounded-2xl shadow-md hover:shadow-xl p-8 flex text-center flex-col gap-4 transition"
            >
              <div className="mb-3 w-full h-[250px] relative flex justify-center items-center">
                {/* Icon on top left */}
                <span
                  className="absolute top-4 left-4 bg-white rounded-full p-3 shadow-md z-20"
                  style={{ zIndex: 3 }}
                >
                  <img
                    src={p.iconUrl}
                    alt={`${p.title} icon`}
                    style={{
                      width: 40,
                      height: 40,
                      // Optionally tint if you want using CSS filter
                      // filter: p.bgColor === "#4FB1FF"
                      //   ? "invert(53%) sepia(78%) saturate(1809%) hue-rotate(176deg) brightness(100%) contrast(101%)"
                      //   : p.bgColor === "#FFD700"
                      //   ? "invert(86%) sepia(67%) saturate(573%) hue-rotate(359deg) brightness(103%) contrast(96%)"
                      //   : "none",
                    }}
                  />
                </span>
                <img
                  src={p.image}
                  alt={`${p.title} visual`}
                  className="object-cover w-full h-full rounded-2xl"
                  style={{ position: "absolute", top: 0, left: 0, zIndex: 1 }}
                  loading="lazy"
                />
              </div>
              <h3 className="text-3xl font-Agatho_Regular font-semibold text-[#0B1D33]">
                {p.title}
              </h3>
              <p className="text-gray-700 leading-relaxed">{p.desc}</p>
            </div>
          ))}
        </div>

        {/* Stats / Quick Highlights */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 text-center mt-10">
          {statsData.map((s, i) => (
            <div key={i} className="flex flex-col items-center">
              <div className="w-20 h-20 mb-2 relative flex justify-center items-center">
                <span
                  className="relative bg-white/80 rounded-full p-2 shadow-md flex items-center justify-center"
                  style={{ zIndex: 2 }}
                >
                  <img
                    src={s.iconUrl}
                    alt={`${s.title} icon`}
                    style={{
                      width: 40,
                      height: 40,
                      // Optionally colorize using filter, adjust as above if needed
                      // filter: s.color === "#4FB1FF"
                      //   ? "invert(53%) sepia(78%) saturate(1809%) hue-rotate(176deg) brightness(100%) contrast(101%)"
                      //   : s.color === "#FFD700"
                      //   ? "invert(86%) sepia(67%) saturate(573%) hue-rotate(359deg) brightness(103%) contrast(96%)"
                      //   : "none",
                    }}
                  />
                </span>
              </div>
              <h4 className="font-semibold mt-3 text-[#0B1D33]">{s.title}</h4>
              <p className="text-gray-600 text-sm mt-1">{s.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CorePrinciples;
